import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "@/layouts/index";
import Home from "@/views/home";
import PageNotFound from "@/views/404.js";
import DemoLink from "../components/demo";

const Routers = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/demo" element={<DemoLink />} />
      </Routes>
    </Router>
  );
};

export default Routers;
